import api from './client';

export const fetchShipments = (params: any) =>
  api.get('/shipments', { params }).then(res => res.data);
